import React from 'react';

const UserContext = React.createContext({
  usuario: null,
  setUsuario: null,
  estadoBackend: null,
  UsuarioLogueadoHandler: () => {},
  UsuarioDeslogueadoHandler: () => {},
  suppressErrors: false,
  setSuppressErrors: () => {},
});

export default UserContext;
